import React from 'react';

import { buildApp, Framework } from '@flint/framework';
import { ThemeProvider } from '@material-ui/core';

import theme from "./theme";
import modules from './modules';
import clients from './common/clients';
import i18n from './i18n';
import Layout from "./layout/Layout";

const intlBuilder = Framework.getIntlBuilder();
Object.keys(i18n).forEach((language) => {
  intlBuilder.add(language, i18n[language]);
});

intlBuilder.setDefaultLang('en').addPseudoLocale('pt').build();
const Comp = buildApp('stg', clients, modules);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Comp layout={Layout} />
    </ThemeProvider>
  );
}

export default App;